import { fetchProduct } from './product-form.js';

const selectors$9 = {
  gridSwatchFieldset: '[data-grid-swatch-fieldset]',
  productItem: '[data-grid-item]',
  productInfo: '[data-product-information]',
  productImage: '[data-product-image]',
  swatchButton: '[data-swatch-button]',
};

const classes$7 = {
  visible: 'is-visible',
  stopEvents: 'no-events',
};

const attributes$7 = {
  handle: 'data-swatch-handle',
  label: 'data-swatch-label',
  swatchCount: 'data-swatch-count',
  variantName: 'data-swatch-variant-name',
  variantTitle: 'data-variant-title',
};

class GridSwatch extends HTMLElement {
  constructor() {
    super();

    this.productItemMouseLeaveEvent = () => this.hideVariantImages();
    this.showVariantImageEvent = (swatchButton) => this.showVariantImage(swatchButton);
    this.resizeEvent = () => this.init();
  }

  connectedCallback() {
    this.handle = this.getAttribute(attributes$7.handle);
    this.productItem = this.closest(selectors$9.productItem);
    this.productInfo = this.closest(selectors$9.productInfo);
    this.productImage = this.productItem.querySelector(selectors$9.productImage);
    this.swatchesStyle = theme.settings.collectionSwatchStyle;
    document.addEventListener('theme:resize:width', this.resizeEvent);

    const label = this.getAttribute(attributes$7.label).trim().toLowerCase();

    fetchProduct(this.handle).then((product) => {
      this.product = product;
      this.colorOption = product.options.find(function (element) {
        return element.name.toLowerCase() === label || null;
      });

      if (this.colorOption) {
        this.init();
      }
    });
  }

  init() {
    this.swatchCount = this.productInfo.querySelector(`[${attributes$7.swatchCount}]`);
    this.swatchFieldset = this.productInfo.querySelector(selectors$9.gridSwatchFieldset);
    this.hideSwatchesTimer = 0;

    if (this.swatchCount.hasAttribute(attributes$7.swatchCount)) {
      if (this.swatchesStyle == 'text-slider') {
        this.swatchCount.addEventListener('mouseenter', () => {
          if (this.hideSwatchesTimer) clearTimeout(this.hideSwatchesTimer);

          this.productInfo.classList.add(classes$7.stopEvents);
          this.swatchFieldset.classList.add(classes$7.visible);
        });

        // Prevent color swatches blinking on mouse move
        this.productInfo.addEventListener('mouseleave', () => {
          this.hideSwatchesTimer = setTimeout(() => {
            this.productInfo.classList.remove(classes$7.stopEvents);
            this.swatchFieldset.classList.remove(classes$7.visible);
          }, 100);
        });
      }

      if (this.swatchesStyle == 'slider' || this.swatchesStyle == 'grid' || this.swatchesStyle == 'limited') {
        this.swatchFieldset.classList.add(classes$7.visible);
      }
    }

    this.bindSwatchButtonEvents();
  }

  bindSwatchButtonEvents() {
    this.querySelectorAll(selectors$9.swatchButton)?.forEach((swatchButton) => {
      // Show variant image when hover on color swatch
      swatchButton.addEventListener('mouseenter', this.showVariantImageEvent);
    });

    this.productItem.addEventListener('mouseleave', this.productItemMouseLeaveEvent);
  }

  showVariantImage(event) {
    const swatchButton = event.target;
    const variantName = swatchButton.getAttribute(attributes$7.variantName)?.replaceAll('"', "'");
    const variantImages = this.productImage.querySelectorAll(`[${attributes$7.variantTitle}]`);
    const variantImageSelected = this.productImage.querySelector(`[${attributes$7.variantTitle}="${variantName}"]`);

    // Hide all variant images
    variantImages?.forEach((image) => {
      image.classList.remove(classes$7.visible);
    });

    // Show selected variant image
    variantImageSelected?.classList.add(classes$7.visible);
  }

  hideVariantImages() {
    // Hide all variant images
    this.productImage.querySelectorAll(`[${attributes$7.variantTitle}].${classes$7.visible}`)?.forEach((image) => {
      image.classList.remove(classes$7.visible);
    });
  }

  disconnectedCallback() {
    document.removeEventListener('theme:resize:width', this.resizeEvent);
  }
}

if (!customElements.get('grid-swatch')) {
  customElements.define('grid-swatch', GridSwatch);
}
